import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { BaseService } from './base.service';
import { User } from './../models/user';
import { CreaCartaRicarica } from './../models/carta';
import { ServizioPerImpianto } from './../models/servizio';
import { Richiesta, StatiRichiestaCrediti } from "../models/richiesta-crediti";
import { ProspettoOnline, IServiziDaRicaricare } from "../models/ricarica-carta";
import { EstrattoContoCreditiVM, ImpiantoIdNomeVM } from '../models/implant';
import { ImplantServizi } from '../models/implantServizi';

@Injectable()
export class ImpiantoService extends BaseService {

  getConnectedImplantInfo() {
    return this.get('api/impianti/implant-info')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getConnectedImplantCostoServiziFlag() {
    return this.get('api/impianti/costoServiziFlag')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getUsers(): Observable<User[]> {
    return this.get('api/utenti/')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.Utenti;
      });
  }

  getUser(UserId): Observable<User> {
    return this.get('api/utenti/' + UserId)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getUtenteByIdCarta(IdCarta: string): Observable<User> {
    return this.get('api/utenti/GetUtenteByIdCarta?Id=' + IdCarta)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postUser(Form: User): Observable<boolean> {
    return this.post('api/utenti', Form)
      .catch((error: any) => {
        console.log("postUser: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  putUser(Form: User): Observable<boolean> {
    return this.put('api/utenti/' + Form.Id, Form)
      .catch((error: any) => {
        console.log("putUser: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  UpdateDataNascita(Form: User): Observable<boolean> {
    return this.put('api/utenti/' + Form.Id + '/updatebirthdate', Form)
      .catch((error: any) => {
        console.log("putUser: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  deleteUser(Id): Observable<boolean> {
    return this.delete('api/utenti/' + Id)
      .catch((error: any) => { console.log("deleteUser: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putRimuoviCarta(UserId): Observable<boolean> {
    return this.put('api/utenti/' + UserId + '/eliminacarta', null)
      .catch((error: any) => { console.log("putRimuoviCarta: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  putAggiungiCarta(UserId, IdCarta, ForzaAssegnazioneCarta): Observable<boolean> {
    return this.put('api/utenti/' + UserId + '/aggiungicarta', { id: UserId, IdCarta: IdCarta, ForzaAssegnazioneCarta: ForzaAssegnazioneCarta })
      .catch((error: any) => {
        console.log("putAggiungiCarta: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  getIdCassaManuale(): Observable<number> {
    return this.get('api/cassa/GetIdCassaManuale')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getCostoServizi(): Observable<ServizioPerImpianto[]> {
    return this.get('api/costoservizi')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putServiziImpianto(Servizi: ImplantServizi, Id: number): Observable<boolean> {
    return this.put('api/impianti/PutServizi/' + Id, Servizi)
      .catch((error: any) => { return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  serviziCreditoTuttiAcquistati(idImpianto: number): Observable<boolean> {
    idImpianto = 1;
    return this.get('api/impianti/' + idImpianto + '/serviziCreditiAcquistati')
      .catch((error: any) => { return Observable.throw(error) })
      .map((response: any) => {
      return response;
    });
    
  }

  getProspettoCartaOnline(IdCarta): Observable<ProspettoOnline[]> {
    return this.get('api/ricaricacarta/' + IdCarta + '/servizi-su-carta')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postRicaricaCartaOnline(Model: IServiziDaRicaricare[], IdCarta: string): Observable<boolean> {
    return this.post('api/ricaricacarta/' + IdCarta + '/online', Model)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getDatiCartaRicarica(): Observable<CreaCartaRicarica> {
    return this.get('api/impianti/impianto/daticartaricarica')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  putCreaCartaRicarica(): Observable<boolean> {
    return this.put('api/impianti/impianto/creacartaricarica', null)
      .catch((error: any) => {
        console.log("putCreaCartaRicarica: ", error);
        return Observable.throw(error);
      })
      .map((response: any) => {
        return true;
      });
  }

  /// RICHIESTA CREDITI
  getRichieste(idImpianto: number, soloPendenti: boolean): Observable<Richiesta[]> {
    var query;
    if (idImpianto == null)
      query = { IdImpianto: null, soloPendenti: soloPendenti };
    if (idImpianto)
      query = { IdImpianto: idImpianto, soloPendenti: soloPendenti };

    let params = new URLSearchParams();
    for (let key in query)
      params.set(key, query[key]);
    //MODIFICARE QUERY STRING DOVREBBE ESSERE "idImpianto=&soloPendenti='BOOL'"
    var url = 'api/richiestacrediti/getrichieste?';
    if (idImpianto == null)
      url = url + "idImpianto=&";

    return this.get(url + params.toString())
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  postRichiestaCrediti(NumeroCrediti: number): Observable<boolean> {
    return this.post('api/RichiestaCrediti', { NumeroCrediti: NumeroCrediti })
      .catch((error: any) => { console.log("post: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  cambioStatoRichiestaCrediti(Id, Stato: StatiRichiestaCrediti): Observable<boolean> {
    return this.post('api/RichiestaCrediti/' + Id + '/cambiostatorichiesta', { Stato: Stato })
      .catch((error: any) => { console.log("cambiostatorichiesta: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }


  deleteRichiestaCrediti(Id): Observable<boolean> {
    return this.delete('api/RichiestaCrediti/' + Id)
      .catch((error: any) => { console.log("deleteRichiestaCrediti: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }
  /// FINE RICHIESTA CREDITI


  getInfoImpianto(): Observable<any> {
    return this.get('api/impianti/info-impianto')
      .catch((error: any) => Observable.throw(error))
      .map((response) => {
        return response;
      });
  }

  //PERMETTEVA AL CLIENTE DI SALVARE I DATI DI UN IMPIANTO
  //putImpiantoByCliente(idImpianto, emailImpianto): Observable<boolean> {
  //  var model = {
  //    EmailImpianto: emailImpianto
  //  }
  //  return this.put('api/impianti/PutImpiantoByCliente/' + idImpianto, model)
  //    .catch((error: any) => {
  //      console.log("putImpiantoByPartner: ", error);
  //      return Observable.throw(error);
  //    })
  //    .map((response: any) => {
  //      return true;
  //    });
  //}

  getListaIdNomeImpianti(): Observable<ImpiantoIdNomeVM[]> {
    return this.get('api/impianti/impiantiOperatore')
      .catch((error: any) => Observable.throw(error))
      .map((response) => {
        return response;
      });
  }

  getServiziVIPbyCard(idCarta: string) {
    return this.get('api/utenti/' + idCarta +'/Servizi-vip')
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      });
  }

  getEstrattoContoCrediti(page, pageRows, dataInizio, dataFine, idImpianto: number): Observable<EstrattoContoCreditiVM> {
    var url = 'api/StoricoMovimenti/GetEstrattoContoCrediti?page=' + page + '&pageRows=' + pageRows + `&ImpiantoId=${idImpianto}&dataInizio=${dataInizio}&dataFine=${dataFine}`;

    return this.get(url)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response;
      })
  }

  getExportEstrattoContoCrediti(dataInizio, dataFine, idImpianto: number): Observable<any> {
    var objUrl = { ImpiantoId: idImpianto, dataInizio: dataInizio, dataFine: dataFine };

    var url = 'api/StoricoMovimenti/ExportEstrattoContoCrediti/?' + $.param(objUrl);

    return this.get(url)
      .catch((error: any) => Observable.throw(error))
      .map((response: any) => {
        return response.NameFile;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/impianto.service.ts